import client from './client';
import { Vehicle, VehicleFuelEfficiency } from '../types/entities';
import { ApiResponse, CreateVehicleRequest } from '../types/api';

export interface UpdateVehicleRequest extends Partial<CreateVehicleRequest> {
  fuelNorm?: number;
  fuelType?: string;
  currentOdometer?: number;
}

export const vehicleAPI = {
  getAll: async (): Promise<Vehicle[]> => {
    const response = await client.get('/vehicles');
    return response.data.data;
  },

  getById: async (id: number): Promise<Vehicle> => {
    const response = await client.get(`/vehicles/${id}`);
    return response.data.data;
  },

  create: async (data: CreateVehicleRequest & { fuelNorm?: number; fuelType?: string }): Promise<Vehicle> => {
    const response = await client.post('/vehicles', data);
    return response.data.data;
  },

  update: async (id: number, data: UpdateVehicleRequest): Promise<Vehicle> => {
    const response = await client.put(`/vehicles/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/vehicles/${id}`);
    return response.data;
  },

  // Fuel efficiency report
  getFuelEfficiencyReport: async (params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<VehicleFuelEfficiency[]> => {
    const response = await client.get('/vehicles/reports/fuel-efficiency', { params });
    return response.data.data;
  },
};
